import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <h2 className="text-background-50 font-heading text-4xl md:text-5xl font-bold mb-6">
              YOYBUY
            </h2>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-sm mb-8">
              YOYBUY Spreadsheet — ваш надёжный помощник в мире онлайн-шопинга. Полное руководство по использованию spreadsheet для покупок, категории товаров и актуальные советы.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" aria-label="Twitter" className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line"></i>
              </a>
              <a href="#" aria-label="Telegram" className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-telegram-line"></i>
              </a>
              <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-instagram-line"></i>
              </a>
              <a href="#" aria-label="YouTube" className="w-10 h-10 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-300 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer">
                <i className="ri-youtube-line"></i>
              </a>
            </div>
          </div>

          <div className="lg:w-1/5">
            <h4 className="text-background-50 text-xs uppercase tracking-widest font-semibold mb-6">
              Контакты
            </h4>
            <div className="space-y-4">
              <div>
                <p className="text-foreground-400 text-xs uppercase tracking-wide mb-1">Email</p>
                <p className="text-foreground-200 text-sm">support@yoybuy.fun</p>
              </div>
              <div>
                <p className="text-foreground-400 text-xs uppercase tracking-wide mb-1">Сайт</p>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-200 text-sm hover:text-background-50 transition-colors"
                >
                  kaspreadsheet.com
                </a>
              </div>
            </div>
          </div>

          <div className="lg:w-1/5">
            <h4 className="text-background-50 text-xs uppercase tracking-widest font-semibold mb-6">
              Навигация
            </h4>
            <div className="space-y-3">
              <Link
                to="/"
                className="block text-foreground-300 text-sm hover:text-background-50 transition-colors"
              >
                Главная
              </Link>
              <Link
                to="/yoybuy-spreadsheet-guide"
                className="block text-foreground-300 text-sm hover:text-background-50 transition-colors"
              >
                Руководство
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="block text-foreground-300 text-sm hover:text-background-50 transition-colors"
              >
                YOYBUY Sheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="block text-foreground-300 text-sm hover:text-background-50 transition-colors"
              >
                Купить сейчас
              </a>
            </div>
          </div>

          <div className="lg:w-1/5">
            <div className="w-full aspect-[3/4] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20product%20photography%20with%20warm%20neutral%20beige%20background%20and%20soft%20natural%20lighting%2C%20elegant%20accessory%20or%20bag%20isolated%20on%20clean%20surface%2C%20editorial%20style%20with%20gentle%20shadows%2C%20high%20end%20aesthetic%2C%20cream%20and%20taupe%20tones&width=600&height=800&seq=footer-product-01&orientation=portrait"
                alt="YOYBUY продукт"
                className="w-full h-full object-cover object-top rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800/50">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; 2026 YOYBUY Spreadsheet. Все права защищены.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-foreground-500 text-xs hover:text-background-50 transition-colors whitespace-nowrap">
              Главная
            </Link>
            <Link to="/yoybuy-spreadsheet-guide" className="text-foreground-500 text-xs hover:text-background-50 transition-colors whitespace-nowrap">
              Руководство
            </Link>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-foreground-500 text-xs hover:text-background-50 transition-colors whitespace-nowrap">
              kaspreadsheet.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}